// src/msalConfig.js
import * as msal from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_BASE_DOMAIN_URL//window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const loginRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE],
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export { msalInstance, loginRequest };
